<!--
* @description  参数1
* @fileName  Summary
* @author userName
* @date 2024-01-29 11:59:42
!-->
<template>
  <div id="Summary" class="Summary">
    <div class="list-item">
      <div class="title">CONSIGNOR</div>
      <div class="lable-item">
        <div class="lable">Company</div>
        <span class="content">{{ shipper.companyName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Name</div>
        <span class="content">{{ shipper.name }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Address</div>
        <span class="content">{{ shipper.address }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Phone</div>
        <span class="content">{{ shipper.tel }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Email</div>
        <span class="content">{{ shipper.email }}</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">CONSIGNEE</div>
      <div class="lable-item">
        <div class="lable">Company</div>
        <span class="content">{{ receiver.companyName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Name</div>
        <span class="content">{{ receiver.name }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Address</div>
        <span class="content">{{ receiver.address }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Phone</div>
        <span class="content">{{ receiver.tel }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Email</div>
        <span class="content">{{ receiver.email }}</span>
      </div>
      <div
        v-if="receiver.companyName!=delivery.companyName||receiver.name!=delivery.name||receiver.address!=delivery.address||receiver.tel!=delivery.tel||receiver.email!=delivery.email"
        class="lable-item"
      >
        <div>
          <el-checkbox disabled :checked="true">Deliver to a different address</el-checkbox>
        </div>
      </div>
    </div>
    <div class="list-item">
      <div class="title">PICKUP ADDRESS</div>
      <div class="lable-item">
        <div class="lable">Company</div>
        <span class="content">{{ pickup.companyName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Name</div>
        <span class="content">{{ pickup.name }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Address</div>
        <span class="content">{{ pickup.address }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Phone</div>
        <span class="content">{{ pickup.tel }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Email</div>
        <span class="content">{{ pickup.email }}</span>
      </div>
    </div>
    <div class="list-item">
      <div class="title">DELIVERY ADDRESS</div>
      <div class="lable-item">
        <div class="lable">Company</div>
        <span class="content">{{ delivery.companyName }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Name</div>
        <span class="content">{{ delivery.name }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Address</div>
        <span class="content">{{ delivery.address }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Phone</div>
        <span class="content">{{ delivery.tel }}</span>
      </div>
      <div class="lable-item">
        <div class="lable">Email</div>
        <span class="content">{{ delivery.email }}</span>
      </div>
    </div>

  </div>
</template>

<script>
import {
  GetOrderAddress
} from '@/api/order.js'
export default {
  name: 'Summary',
  components: {
    // 组件的引用
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      data: {},
      shipper: {},
      receiver: {},
      pickup: {},
      delivery: {}
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    init(data) {
      this.data = data
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 0
      }).then(res => {
        if (res.code == 200) {
          this.shipper = res.data
        }
      })
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 1
      }).then(res => {
        if (res.code == 200) {
          this.receiver = res.data
        }
      })
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 2
      }).then(res => {
        if (res.code == 200) {
          this.pickup = res.data
        }
      })
      GetOrderAddress({
        orderNo: this.data.orderNo,
        addrType: 7
      }).then(res => {
        if (res.code == 200) {
          this.delivery = res.data
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	.Summary {
		display: flex;
		flex-wrap: wrap;
		width: auto;
		padding: 0 8px;

		.list-item {
			width: 524px;
			height: 230px;
			background: rgba(0, 0, 0, 0.02);
			border-radius: 8px;
			padding: 8px 16px;
			margin: 12px 16px;
			text-align: left;

			.title {
				font-size: 14px;
				font-family: PingFangSC, PingFang SC;
				font-weight: 500;
				color: #333333;
				height: 32px;
				line-height: 32px;
			}

			.lable-item {
				display: flex;
				height: 32px;
				align-items: center;

				.lable {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #666666;
					width: 132px;
				}

				.content {
					font-size: 13px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #333333;
				}

				.content-cancel {
					color: #E95506;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>
